import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFigmaOutline({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M2.5 13.017c0-1.05.543-1.977 1.36-2.512A2.989 2.989 0 0 1 2.5 7.998c0-1.05.542-1.976 1.359-2.508A2.989 2.989 0 0 1 2.5 2.983c0-1.61 1.26-2.92 2.84-2.98h.001L5.453 0h5.094c1.627 0 2.948 1.336 2.953 2.983 0 1.05-.542 1.976-1.359 2.507A3.004 3.004 0 0 1 13.5 8.003c0 1.609-1.265 2.92-2.84 2.98h-.002l-.11.003h-.065a2.928 2.928 0 0 1-2.014-.806v2.807A3.01 3.01 0 0 1 5.467 16 2.98 2.98 0 0 1 2.5 13.017zm2.953-2.036H7.53v2l-.003.103a2.068 2.068 0 0 1-2.06 1.969c-1.12 0-2.03-.914-2.03-2.036 0-1.123.905-2.036 2.015-2.036zm5.03-5.02h.064c1.11 0 2.015.914 2.015 2.037 0 1.122-.905 2.035-2.015 2.035h-.062l-.1-.002a2.03 2.03 0 0 1-1.916-2.033c0-1.123.905-2.037 2.014-2.037zM3.438 7.998a2.03 2.03 0 0 1 1.916-2.034l.1-.003H7.53v4.072H5.453c-1.11 0-2.015-.913-2.015-2.035zm7.11-2.979H8.468V.947h2.078c1.11 0 2.015.914 2.015 2.036 0 1.123-.905 2.036-2.015 2.036zM5.452.947H7.53V5.02H5.454l-.1-.002a2.03 2.03 0 0 1-1.916-2.034c0-1.122.905-2.036 2.015-2.036z"/>
        </svg>
    );
}

export default IconFigmaOutline;
